import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const RectangleShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 0h512v512H0z"
    })
  });
};

export { RectangleShape };
//# sourceMappingURL=RectangleShape.js.map
